import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import "./sidebar.css"; // Import your CSS file
import { useNavigate } from "react-router-dom";
import logoSmall from "../logo_small.png";

function Sidebarnew() {
  const navigate = useNavigate();
  // State to manage sidebar visibility
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);
  const [isReportsDropdownVisible, setIsReportsDropdownVisible] = useState(false);
  const [isMastersDropdownVisible ,setIsMastersDropdownVisible] =useState(false);

  const toggleReportsDropdown = () => {
    setIsReportsDropdownVisible(!isReportsDropdownVisible);
  };
  const toggleMastersDropdown = () =>{
    setIsMastersDropdownVisible(!isMastersDropdownVisible);
  }
  // Function to toggle sidebar visibility
  const toggleSidebar = () => {
    setIsSidebarVisible(!isSidebarVisible);
  };

  // Close sidebar if window is resized above a certain width
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setIsSidebarVisible(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <div
        className={`wrapper sidebar js-sidebar ${
          isSidebarVisible ? "visible" : ""
        }`}
      >
        <a href="#" className="closebtn" onClick={toggleSidebar}>
          &times;
        </a>
        <nav id="sidebar">
          <div className="sidebar-content js-simplebar">
            <a className="sidebar-brand" href="#">
              <div className="d-flex justify-content-between align-items-center">
                <img
                  src={logoSmall}
                  className="img-fluid"
                  style={{ width: "25%" }}
                />
                <span className="sidebar-brand-text align-middle">
                  {/* Your brand text */}
                </span>
              </div>
              <svg
                className="sidebar-brand-icon align-middle"
                width="32px"
                height="32px"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#FFFFFF"
                strokeWidth="1.5"
                strokeLinecap="square"
                strokeLinejoin="miter"
                color="#FFFFFF"
                style={{ marginLeft: "-3px" }}
              >
                <path d="M12 4L20 8.00004L12 12L4 8.00004L12 4Z"></path>
                <path d="M20 12L12 16L4 12"></path>
                <path d="M20 16L12 20L4 16"></path>
              </svg>
            </a>

            <ul className="sidebar-nav">
              <li className="sidebar-item">
                <NavLink
                  exact={"true"}
                  to="/dashboard"
                  className="sidebar-link"
                  activeclassname="active"
                >
                  <i className="fa-solid fa-gauge-high"></i>{" "}
                  <span className="align-middle">Dashboard</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                onClick={toggleMastersDropdown}
                style={{backgroundColor:"white" ,color:"black"}}
                exact={"true"}
                className="sidebar-link"
                activeclassname="active"
                >
                  <i class="fa-solid fa-gear"></i>
                  <span className="align-middle">Masters</span>
                  <i
                    className={`fa-solid ${
                      isMastersDropdownVisible ? "fa-chevron-up" : "fa-chevron-down"
                    } dropdown-icon`}
                    style={{ marginLeft: "87px" }}
                  ></i>
                </NavLink>
                {isMastersDropdownVisible && <ul className="sidebar-submenu" style={{paddingLeft: "20px", marginTop: "10px",listStyleType:"none"}}>
                <li>
                  <NavLink
                      exact="true"
                      to="/category"
                      className="sidebar-link"
                      activeclassname="active"
                      style={{ padding: "10px 5px", display: "block" }}
                    >
                      Category
                    </NavLink>
                  </li>
                  <li className="sidebar-subitem">
                    <NavLink
                      exact="true"
                      to="/sub-category"
                      className="sidebar-link"
                      activeclassname="active"
                      style={{ padding: "10px 5px", display: "block" }}
                    >
                      Sub Category
                    </NavLink>
                  </li>
                  </ul>}
              </li>

              <li className="sidebar-item">
                <NavLink onClick={toggleReportsDropdown} style={{backgroundColor:"white",color:"black"}}
                  exact={"true"}
                  
                  className="sidebar-link"
                  activeclassname="active"
                >
                  <i className="fa-solid fa-sheet-plastic"></i>{" "}
                  <span className="align-middle">Reports</span>
                  <i
                    className={`fa-solid ${
                      isReportsDropdownVisible ? "fa-chevron-up" : "fa-chevron-down"
                    } dropdown-icon`}
                    style={{ marginLeft: "90px" }}
                  ></i>
                </NavLink>
                {isReportsDropdownVisible&&<ul className="sidebar-submenu" style={{ paddingLeft: "20px", marginTop: "10px",listStyleType:"none" }}>
                  <li className="sidebar-subitem">
                    <NavLink
                      exact="true"
                      to="/approval-pending-reports"
                      className="sidebar-link"
                      activeclassname="active"
                      style={{ padding: "10px 5px", display: "block" }}
                    >
                     Waiting For Approval Reports
                    </NavLink>
                  </li>
                  <li>
                  <NavLink
                      exact="true"
                      to="/reports"
                      className="sidebar-link"
                      activeclassname="active"
                      style={{ padding: "10px 5px", display: "block" }}
                    >
                      UnVerified Reports
                    </NavLink>
                  </li>
                  <li className="sidebar-subitem">
                    <NavLink
                      exact="true"
                      to="/module_reports"
                      className="sidebar-link"
                      activeclassname="active"
                      style={{ padding: "10px 5px", display: "block" }}
                    >
                      Verified Reports
                    </NavLink>
                  </li>
                  <li className="sidebar-subitem">
                    <NavLink
                      exact="true"
                      to="/zone-wise-report"
                      className="sidebar-link"
                      activeclassname="active"
                      style={{ padding: "10px 5px", display: "block" }}
                    >
                      Zone Wise Reports
                    </NavLink>
                  </li>
                  
                  {/* <li className="sidebar-subitem">
                    <NavLink
                      exact="true"
                      to="/grouped-reports"
                      className="sidebar-link"
                      activeclassname="active"
                      style={{ padding: "10px 5px", display: "block" }}
                    >
                      Grouped Reports
                    </NavLink>
                  </li> */}
                </ul>}
              </li>

              <li className="sidebar-item">
                <NavLink
                  exact={"true"}
                  to="/surveyor"
                  className="sidebar-link"
                  activeclassname="active"
                >
                  <i className="fa-solid fa-sheet-plastic"></i>{" "}
                  <span className="align-middle">Surveyor</span>
                </NavLink>
              </li>

              <li
                onClick={() => {
                  localStorage.removeItem("userId");
                  localStorage.removeItem("token");
                  localStorage.removeItem("userName");
                  localStorage.removeItem("filters");
                  localStorage.removeItem("IsAdmin");
                  navigate("/");
                }}
              >
                <NavLink
                  style={{
                    background: "#F4F7FB",
                    color: "black",
                    boxShadow:
                      "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                  }}
                  className="sidebar-link"
                >
                  <i className="fa-solid fa-right-from-bracket"></i>{" "}
                  <span className="align-middle">Logout</span>
                </NavLink>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </>
  );
}

export default Sidebarnew;

